import React from "react";
import { FlameIcon } from "lucide-react";
import { useOfferClock } from "../hooks/useOfferClock";
import { TOTAL_SPOTS } from "../data/offer";
type ScarcityBarProps = {
  tone?: "dark" | "light";
};
export function ScarcityBar({
  tone = "light"
}: ScarcityBarProps) {
  const {
    spotsLeft
  } = useOfferClock();
  const filled = (TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100;
  const dark = tone === "dark";
  return <div className="w-full" data-id="element-308" data-mp="2b5yt613ennaw">
      <div className="mb-2 flex items-center justify-between gap-3 text-sm font-bold" data-id="element-309" data-mp="2b8ur3pf96bzc">
        <span className={`flex items-center gap-1.5 ${dark ? "text-white" : "text-ink"}`} data-id="element-310" data-mp="2g74o85kjfmnl">
          <FlameIcon className="h-4 w-4 text-red-500" aria-hidden="true" data-id="element-311" data-mp="227mvjf44fp8y" />
          Only <span className="text-red-500" data-id="element-312" data-mp="2766fj9z5mqyo">{spotsLeft} spots</span> left at $27
        </span>
        <span className={dark ? "text-brand-200" : "text-muted"} data-id="element-313" data-mp="efh07wc1bo4">{Math.round(filled)}% claimed</span>
      </div>
      <div className={`h-4 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-brand-100"}`} role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-314" data-mp="5cgywpi0v4y0">
        <div className="h-full rounded-full bg-red-500 transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-315" data-mp="3dbmw6k8cthcy" />
      </div>
      <p className={`mt-2 text-xs ${dark ? "text-brand-200" : "text-muted"}`} data-id="element-316" data-mp="2knqypdaynlf4">
        When the remaining spots are gone, the promotional price closes.
      </p>
    </div>;
}